import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import React, { useState, useEffect, useLayoutEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

// -----------------------------
// Brand config
// -----------------------------
const BRANDS = {
  earthscan: {
    key: 'earthscan',
    name: 'EarthScan',
    siteUrl: 'https://earthscan.sobekglobal.com',
    logo: '/Asset 2.png',
  },
  sobek: {
    key: 'sobek',
    name: 'SOBEK',
    siteUrl: 'https://sobekglobal.com',
    logo: '/Asset 2.png',
  },
  drone: {
    key: 'drone',
    name: 'Drone Pilot',
    siteUrl: 'https://dronepilott.com',
    logo: '/Asset 2.png',
  },
};

// ====== OAuth (Google) Back-end Endpoint ======
const GOOGLE_OAUTH_START = 'https://user-hub.com/oauth/google/start.php';

// ====== Mobile OTP Endpoints ======
const MOBILE_OTP_SEND   = 'https://user-hub.com/otp/send.php';
const MOBILE_OTP_VERIFY = 'https://user-hub.com/otp/verify.php';

// ====== Forgot Password Endpoint ======
const FORGOT_PASSWORD_ENDPOINT = 'https://user-hub.com/forgot.php';

// ====== Country list for phone codes (flag + dial code) ======
const countries = [
  { code: '+20',  name: 'Egypt',                flag: '🇪🇬' },
  { code: '+966', name: 'Saudi Arabia',         flag: '🇸🇦' },
  { code: '+971', name: 'United Arab Emirates', flag: '🇦🇪' },
  { code: '+1',   name: 'United States',        flag: '🇺🇸' },
  { code: '+44',  name: 'United Kingdom',       flag: '🇬🇧' },
  { code: '+49',  name: 'Germany',              flag: '🇩🇪' },
  { code: '+39',  name: 'Italy',                flag: '🇮🇹' },
  { code: '+34',  name: 'Spain',                flag: '🇪🇸' },
  { code: '+33',  name: 'France',               flag: '🇫🇷' },
  { code: '+41',  name: 'Switzerland',          flag: '🇨🇭' },
  { code: '+90',  name: 'Turkey',               flag: '🇹🇷' },
  { code: '+974', name: 'Qatar',                flag: '🇶🇦' },
  { code: '+965', name: 'Kuwait',               flag: '🇰🇼' },
  { code: '+973', name: 'Bahrain',              flag: '🇧ahrain' },
  { code: '+968', name: 'Oman',                 flag: '🇴🇲' },
  { code: '+962', name: 'Jordan',               flag: '🇯🇴' },
  { code: '+961', name: 'Lebanon',              flag: '🇱🇧' },
  { code: '+212', name: 'Morocco',              flag: '🇲🇦' },
  { code: '+213', name: 'Algeria',              flag: '🇩🇿' },
  { code: '+216', name: 'Tunisia',              flag: '🇹🇳' },
  { code: '+249', name: 'Sudan',                flag: '🇸🇩' },
  { code: '+254', name: 'Kenya',                flag: '🇰🇪' },
  { code: '+27',  name: 'South Africa',         flag: '🇿🇦' },
  { code: '+234', name: 'Nigeria',              flag: '🇳🇬' },
  { code: '+91',  name: 'India',                flag: '🇮🇳' },
  { code: '+62',  name: 'Indonesia',            flag: '🇮🇩' },
  { code: '+81',  name: 'Japan',                flag: '🇯🇵' },
  { code: '+82',  name: 'South Korea',          flag: '🇰🇷' },
  { code: '+86',  name: 'China',                flag: '🇨🇳' },
  { code: '+852', name: 'Hong Kong',            flag: '🇭🇰' },
  { code: '+853', name: 'Macau',                flag: '🇲🇴' },
  { code: '+61',  name: 'Australia',            flag: '🇦🇺' },
  { code: '+64',  name: 'New Zealand',          flag: '🇳🇿' },
  { code: '+52',  name: 'Mexico',               flag: '🇲🇽' },
  { code: '+55',  name: 'Brazil',               flag: '🇧🇷' },
  { code: '+54',  name: 'Argentina',            flag: '🇦🇷' },
  { code: '+7',   name: 'Russia',               flag: '🇷🇺' },
  { code: '+380', name: 'Ukraine',              flag: '🇺🇦' },
  { code: '+46',  name: 'Sweden',               flag: '🇸🇪' },
  { code: '+47',  name: 'Norway',               flag: '🇳🇴' },
  { code: '+45',  name: 'Denmark',              flag: '🇩🇰' },
  { code: '+31',  name: 'Netherlands',          flag: '🇳🇱' },
  { code: '+32',  name: 'Belgium',              flag: '🇧🇪' },
  { code: '+30',  name: 'Greece',               flag: '🇬🇷' },
  { code: '+48',  name: 'Poland',               flag: '🇵🇱' },
  { code: '+351', name: 'Portugal',             flag: '🇵🇹' },
  { code: '+420', name: 'Czech Republic',       flag: '🇨🇿' },
  { code: '+43',  name: 'Austria',              flag: '🇦🇹' },
  { code: '+353', name: 'Ireland',              flag: '🇮🇪' },
  { code: '+63',  name: 'Philippines',          flag: '🇵🇭' },
  { code: '+84',  name: 'Vietnam',              flag: '🇻🇳' },
  { code: '+66',  name: 'Thailand',             flag: '🇹🇭' },
  { code: '+65',  name: 'Singapore',            flag: '🇸🇬' },
  { code: '+60',  name: 'Malaysia',             flag: '🇲🇾' },
  { code: '+974', name: 'Qatar',                flag: '🇶🇦' }, // duplicate ok
];

// ---- helpers ----
function getServiceParam() {
  let s = new URLSearchParams(window.location.search).get('service');
  if (s) return s;

  const h = window.location.hash || '';
  const qIndex = h.indexOf('?');
  if (qIndex !== -1) {
    const hs = new URLSearchParams(h.substring(qIndex + 1));
    s = hs.get('service');
    if (s) return s;
  }
  return '';
}

function getParamFromSearchOrHash(name) {
  const sp = new URLSearchParams(window.location.search);
  if (sp.has(name)) return sp.get(name);
  const h = window.location.hash || '';
  const i = h.indexOf('?');
  if (i !== -1) {
    const hs = new URLSearchParams(h.substring(i + 1));
    if (hs.has(name)) return hs.get(name);
  }
  return null;
}

function detectBrandKey() {
  const explicit = (getParamFromSearchOrHash('brand') || '').toLowerCase();
  if (explicit && BRANDS[explicit]) return explicit;

  const s = (getServiceParam() || '').toLowerCase();

  const candidates = [];
  if (s) {
    candidates.push(s);
    try { candidates.push(new URL(s).hostname.toLowerCase()); } catch (_) {}
  }

  if (document.referrer) {
    candidates.push(document.referrer.toLowerCase());
    try { candidates.push(new URL(document.referrer).hostname.toLowerCase()); } catch (_) {}
  }

  candidates.push(window.location.hostname.toLowerCase());

  const match = (hay) => (
    /dronepilott|dronepilot|drone/.test(hay) ? 'drone'
      : /sobekglobal|sobek/.test(hay) ? 'sobek'
      : /earthscan|earth-scan|earth\sscan/.test(hay) ? 'earthscan'
      : null
  );

  for (const h of candidates) {
    const m = match(h);
    if (m) return m;
  }
  return 'earthscan';
}

// ===== Helpers for OAuth URL =====
function getServiceOrDefault() {
  const s = getServiceParam();
  if (s) return s;

  const brand = detectBrandKey();
  const defaultMap = {
    earthscan: 'https://earthscan.sobekglobal.com/',
    sobek: 'https://sobekglobal.com/',
    drone: 'https://dronepilott.com/',
  };

  return defaultMap[brand] || 'https://earthscan.sobekglobal.com/';
}


function buildOAuthUrl({ brandKey }) {
  const service = getServiceOrDefault();
  const u = new URL(GOOGLE_OAUTH_START);
  u.searchParams.set('service', service);
  u.searchParams.set('brand', brandKey);
  return u.toString();
}

/* =========================
   Mode helpers
   mode = normal | popup | embed
   ========================= */
function getMode() {
  const m = (getParamFromSearchOrHash('mode') || '').toLowerCase();
  if (m === 'popup' || m === 'embed') return m;
  if (window.self !== window.top) return 'embed'; // داخل iframe
  return 'normal';
}

// helper to notify parent (WordPress) after auth
function sendAuthToParent(base) {
  const mode = getMode();
  if (mode === 'normal') return;

  const payload = { type: 'auth:success', ...base };

  try {
    const target = window.opener || window.parent;
    if (target) {
      target.postMessage(payload, '*');
    }
  } catch (err) {
    console.error('postMessage failed', err);
  }

  if (window.opener && mode === 'popup') {
    try { window.close(); } catch {}
  }
}

// ====== fetch with timeout ======
async function fetchJsonWithTimeout(url, options = {}, ms = 15000, fallbackUrl) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), ms);
  try {
    const res = await fetch(url, { ...options, signal: controller.signal });
    const raw = await res.text();
    let data; try { data = JSON.parse(raw); } catch { throw new Error('Bad server response'); }
    return { res, data, raw };
  } catch (e) {
    if (fallbackUrl) {
      try {
        const res2 = await fetch(fallbackUrl, { ...options, signal: controller.signal });
        const raw2 = await res2.text();
        let data2; try { data2 = JSON.parse(raw2); } catch { throw new Error('Bad server response'); }
        return { res: res2, data: data2, raw: raw2 };
      } catch (e2) {
        throw e2;
      }
    }
    throw e;
  } finally {
    clearTimeout(id);
  }
}

const LoginRegisterSobek = () => {
  const [isRegister, setIsRegister] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [emailOrUsername, setEmailOrUsername] = useState('');
  const [passwordValue, setPasswordValue] = useState('');

  // register fields
  const [username, setUsername] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const [countryCode, setCountryCode] = useState('+966');
  const [localPhone, setLocalPhone] = useState('');
  const whatsappFull = `${countryCode}${localPhone}`;

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const [hoveredLocation, setHoveredLocation] = useState({
    type: 'bounds',
    coords: null,
  });

  const brandKey = useMemo(() => detectBrandKey(), []);
  const brand = BRANDS[brandKey] || BRANDS.earthscan;
  const mode = getMode();

  const [bannerMsg, setBannerMsg] = useState('');
  const LS_CHECK_KEY = 'once_check_email_banner';
  const LS_VERIFIED_KEY = 'once_verified_banner';

  const cleanUrl = () => {
    const url = new URL(window.location.href);
    url.search = '';
    window.history.replaceState({}, '', url.toString());
  };

  const initialParamsRef = useRef(new URLSearchParams(window.location.search));

  useLayoutEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    if (sp.has('check-email') || sp.has('verified')) {
      cleanUrl();
    }
  }, []);

  useEffect(() => {
    const sp = initialParamsRef.current;
    const checkEmail = sp.get('check-email') === '1';
    const verified = sp.get('verified');

    if (verified === '1') {
      if (!sessionStorage.getItem(LS_VERIFIED_KEY)) {
        setBannerMsg('Your account is now activated. You can sign in.');
        sessionStorage.setItem(LS_VERIFIED_KEY, '1');
      } else {
        setBannerMsg('');
      }
      sessionStorage.removeItem(LS_CHECK_KEY);
      return;
    }

    if (checkEmail) {
      if (!sessionStorage.getItem(LS_CHECK_KEY)) {
        setBannerMsg("We've sent a confirmation email. Please check your inbox and click the link to activate your account.");
        sessionStorage.setItem(LS_CHECK_KEY, '1');
      } else {
        setBannerMsg('');
      }
    }
  }, []);

  useEffect(() => {
    const htmlEl = document.documentElement;
    const prevHtmlBg = htmlEl.style.backgroundColor;
    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyMargin = document.body.style.margin;

    htmlEl.style.backgroundColor = '#111';
    document.body.style.backgroundColor = '#111';
    document.body.style.margin = '0';

    return () => {
      htmlEl.style.backgroundColor = prevHtmlBg;
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.margin = prevBodyMargin;
    };
  }, []);

  const navigate = useNavigate();


useEffect(() => {
  const onMsg = (ev) => {
    const d = ev?.data;
    if (!d || d.type !== 'auth:success') return;

    if (d.ticket) {
      try {
        sessionStorage.setItem('userhub_ticket', d.ticket);
        sessionStorage.setItem('userhub_brand', d.brand || brandKey);
      } catch {}

      closeMobileModal?.();

      // روحي /profile بنفس منطق OTP
      navigate('/profile', { state: { ticket: d.ticket, brand: d.brand || brandKey } });
    }
  };

  window.addEventListener('message', onMsg);
  return () => window.removeEventListener('message', onMsg);
}, [navigate, brandKey]);




useEffect(() => {
  const ticket = getParamFromSearchOrHash('ticket');
  if (!ticket) return;

  // ✅ خزني التذكرة لأي refresh / logout سريع
  sessionStorage.setItem('uh_ticket', ticket);

  // ✅ نظّفي الـ URL (اختياري بس مفيد)
  const url = new URL(window.location.href);
  url.searchParams.delete('ticket');
  window.history.replaceState({}, '', url.toString());

  // ✅ ادخلي البروفايل بالتذكرة
  navigate('/profile', { state: { ticket } });
}, [navigate]);



  // ✅ Listener لنتيجة Google OAuth Popup (لو الـ backend بيرسل postMessage)
  useEffect(() => {
    const onMessage = (event) => {
      if (!event || event.origin !== 'https://user-hub.com') return;
      const d = event.data || {};
      if (d.type !== 'auth:success') return;

      // أولوية: next ثم cas ثم ticket
      if (d.next) {
        window.location.href = d.next;
        return;
      }
      if (d.cas) {
        window.location.href = d.cas;
        return;
      }
      if (d.ticket) {
        navigate('/profile', { state: { ticket: d.ticket } });
      }
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [navigate]);

  const MapUpdater = ({ hoveredLocation }) => {
    const map = useMap();
    useEffect(() => {
      if (!hoveredLocation || !hoveredLocation.coords) return;
      if (hoveredLocation.type === 'bounds') {
        const bounds = L.latLngBounds(hoveredLocation.coords);
        map.fitBounds(bounds);
      } else if (hoveredLocation.type === 'point') {
        map.setView(hoveredLocation.coords, 13);
      }
    }, [hoveredLocation, map]);
    return null;
  };

  const mapIcon = L.icon({
    iconUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  });

  // ====== Google OAuth (Front-end handler) ======
 const handleGoogleAuth = () => {
  const baseUrl = buildOAuthUrl({ brandKey });

  // ✅ أهم تعديل: في normal اعملي redirect مباشر بدل popup (أثبت بكتير)
  if (mode === 'normal') {
    window.location.href = baseUrl;
    return;
  }

  // embed/popup: خلي popup زي ما هو
  const url = baseUrl + '&mode=popup';
  const w = 480, h = 640;
  const left = window.screenX + (window.outerWidth - w) / 2;
  const top  = window.screenY + (window.outerHeight - h) / 2;

  const win = window.open(url, 'userhub_login', `width=${w},height=${h},left=${left},top=${top}`);

  if (!win || win.closed || typeof win.closed === 'undefined') {
    window.location.href = baseUrl;
  }
};

  // ====== Mobile OTP state & handlers ======
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [mobileStep, setMobileStep] = useState('enter'); // 'enter' | 'code'
  const [mobileLoading, setMobileLoading] = useState(false);

  const [mobileCountryCode, setMobileCountryCode] = useState('+966');
  const [mobileLocalPhone, setMobileLocalPhone] = useState('');
  const mobilePhoneFull = `${mobileCountryCode}${mobileLocalPhone}`;

  const [mobileOtp, setMobileOtp] = useState('');

  const openMobileModal = () => {
    setShowMobileModal(true);
    setMobileStep('enter');
    setMobileLocalPhone('');
    setMobileOtp('');
  };
  const closeMobileModal = () => setShowMobileModal(false);

  // ✅ تعديل 1: إرسال OTP (JSON + بدون credentials)
  const handleMobileSend = async () => {
    if (!mobileLocalPhone.trim()) { alert('Please enter your mobile number'); return; }
    try {
      setMobileLoading(true);
      const service = getServiceOrDefault();

      const payloadObj = {
        phone: mobilePhoneFull.trim(),
        brand: brandKey,
        service,
        mode: isRegister ? 'register' : 'login',
      };

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payloadObj),
        credentials: 'omit', // ✅ مهم: OTP مش محتاج cookies
        mode: 'cors',
      };

      const { res, data } = await fetchJsonWithTimeout(
        MOBILE_OTP_SEND,
        options,
        15000
      );

      const ok = res.ok && (data.success || data.ok);
      if (!ok) throw new Error(data.error || data.message || 'Failed to send OTP');

      // للتطوير: لو السيرفر رجّع debug_otp (زي send.php عندك) هيتسجل في console
      if (data && data.debug_otp) {
        console.log('[DEV OTP]', data.debug_otp);
      }

      setMobileStep('code');
    } catch (e) {
      alert('❌ ' + (e.name === 'AbortError' ? 'Network timeout. Try again.' : e.message));
    } finally {
      setMobileLoading(false);
    }
  };

  // ✅ تعديل 2: Verify OTP (JSON + بدون credentials)
 const handleMobileVerify = async () => {
  if (!mobileOtp.trim()) { alert('Please enter the code'); return; }
  try {
    setMobileLoading(true);
    const service = getServiceOrDefault();

    const payload = new URLSearchParams({
      phone: mobilePhoneFull.trim(),
      otp: mobileOtp.trim(),
      brand: brandKey,
      service, // ✅ مهم جدًا (كان ناقص)
      mode: isRegister ? 'register' : 'login',
    }).toString();

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Accept': 'application/json',
      },
      body: payload,
      credentials: 'include',
      mode: 'cors',
    };

    const { res, data } = await fetchJsonWithTimeout(
      MOBILE_OTP_VERIFY,
      options,
      15000
    );

    const ok = res.ok && (data.success || data.ok);
    if (!ok) throw new Error(data.error || data.message || 'Verification failed');

    const redirectService = service;

    // ✅ خزّني التذكرة عشان الـ profile يلاقيها حتى لو عمل refresh
    if (data.ticket) {
      sessionStorage.setItem('uh_ticket', data.ticket);
    }

    // لو السيرفيس هي نفس الـ SPA (localhost أو نفس الدومين) ادخلي profile داخليًا بدل redirect
    const isSameOriginService =
      typeof redirectService === 'string' &&
      redirectService.startsWith(window.location.origin);

    if (mode !== 'normal') {
      // embed/popup: ابعتي التذكرة للـ parent
      sendAuthToParent({
        brand: brandKey,
        service: redirectService,
        next: data.next,
        ticket: data.ticket,
      });
      return;
    }

    if (isSameOriginService && data.ticket) {
      // ✅ دخول ثابت بدون ما يلف على CAS
      navigate('/profile', { state: { ticket: data.ticket } });
      return;
    }

    // غير كده: استخدمي next اللي راجع من السيرفر (هيكون service + ticket)
    if (data.next) {
      window.location.href = data.next;
      return;
    }

    // fallback القديم
    const cas = `https://user-hub.com/cas/login.php?service=${encodeURIComponent(redirectService)}&brand=${encodeURIComponent(brandKey)}`;
    window.location.href = cas;

  } catch (e) {
    alert('❌ ' + (e.name === 'AbortError' ? 'Network timeout. Try again.' : e.message));
  } finally {
    setMobileLoading(false);
  }
};

  // ====== Forgot Password ======
  const [forgotId, setForgotId] = useState('');
  const [forgotLoading, setForgotLoading] = useState(false);

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    const id = (forgotId || '').trim();
    if (!id) { alert('Please enter your email or username'); return; }

    try {
      setForgotLoading(true);

      const { res, data } = await fetchJsonWithTimeout(
        FORGOT_PASSWORD_ENDPOINT,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ identifier: id, brand: brandKey }),
          credentials: 'include',
          mode: 'cors',
        },
        15000
      );

      const ok = res.ok && (data.success || data.ok);
      if (!ok) {
        throw new Error(data.error || data.message || 'Reset failed');
      }

      alert('✅ A reset link has been sent if the account exists. Please check your inbox.');
      setShowResetPassword(false);
      setForgotId('');
    } catch (err) {
      alert('❌ ' + (err.name === 'AbortError' ? 'Network timeout. Try again.' : err.message));
    } finally {
      setForgotLoading(false);
    }
  };

  const handleRegister = async () => {
    if (loading) return;

    const u = username.trim();
    const n = name.trim();
    const e = email.trim();
    const w = whatsappFull.trim();
    const p = password;
    const c = confirmPassword;

    if (!u || !n || !e || !w || !p || !c) {
      alert('Please fill all required fields');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) {
      alert('Please enter a valid email');
      return;
    }
    if (p !== c) {
      alert('Passwords do not match');
      return;
    }

    const payload = { username: u, name: n, email: e, whatsapp: w, password: p };

    const sp = new URLSearchParams(window.location.search);
    const serviceParam = sp.get('service') || '';
    const finalService = serviceParam || getServiceOrDefault();

    const goToLoginWithMsg = (url) => {
      alert("We've sent a confirmation email to your inbox. Please open the link to activate your account.");
      if (mode === 'normal') {
        window.location.href = url;
      } else {
        sendAuthToParent({
          brand: brandKey,
          service: finalService,
          registered: true,
        });
      }
    };

    try {
      setLoading(true);

      const url = 'https://user-hub.com/register.php' + (serviceParam ? `?service=${encodeURIComponent(serviceParam)}` : '');

      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const raw = await res.text();
      let data;
      try {
        data = JSON.parse(raw);
      } catch {
        console.error('Non-JSON response from server:', raw);
        alert('Server error. Check console for details.');
        return;
      }

      if (!res.ok) {
        if (res.status === 409) {
          const field = data.field || '';
          alert(
            field === 'username'
              ? '❌ Username already exists'
              : field === 'email'
                ? '❌ Email already exists'
                : data.error || '❌ Username or email already exists'
          );
          return;
        }
        alert(`❌ Server error (${res.status}): ${data.error || data.message || 'Unknown error'}`);
        return;
      }

      if (data.success) {
        if (data.redirect) {
          const to = new URL(data.redirect, window.location.origin);
          if (serviceParam && !to.searchParams.has('service')) {
            to.searchParams.set('service', serviceParam);
          }
          goToLoginWithMsg(to.toString());
          return;
        }

        const msg = (data.message || '').toLowerCase();
        if (msg.includes('confirmation email sent') || msg.includes('confirmation')) {
          const to = new URL('/login', window.location.origin);
          to.searchParams.set('check-email', '1');
          if (serviceParam) to.searchParams.set('service', serviceParam);
          goToLoginWithMsg(to.toString());
          return;
        }

        alert(data.message || 'Registered, but confirmation email not sent.');
      } else {
        alert('❌ ' + (data.error || data.message || 'Registration failed'));
      }
    } catch (err) {
      console.error(err);
      alert('⚠ Network error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    const payload = {
      usernameOrEmail: emailOrUsername,
      password: passwordValue,
    };

    const service = getServiceOrDefault();

    try {
      const url =
        `https://user-hub.com/login.php?service=${encodeURIComponent(service)}&brand=${encodeURIComponent(brandKey)}`;

      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'include',
        body: JSON.stringify(payload),
        redirect: 'follow',
      });
      const raw = await res.text();
      let data;
      try { data = JSON.parse(raw); }
      catch {
        console.error('Non-JSON response from server:', raw);
        alert('Server error. Check console for details.');
        return;
      }

      if (res.ok && (data.ok || data.success)) {
        if (mode !== 'normal') {
          sendAuthToParent({
            brand: brandKey,
            service: data.service || service,
            next: data.next,
            ticket: data.ticket,
            cas: data.cas,
          });
          return;
        }

        if (data.next) {
          navigate('/profile', { state: { ticket: data.ticket } });
        }
      } else {
        alert('❌ ' + (data.error || data.message || 'Login failed'));
      }
    } catch (err) {
      alert('⚠ Error: ' + err.message);
    }
  };

  return (
    <div style={styles.page}>
      {mode === 'normal' && (
        <div style={styles.header}>
          <div style={styles.headerInner}>
            <a href="https://sobekglobal.com/" style={styles.logoSection} aria-label="SOBEK Global">
              <img src={brand.logo} alt={`${brand.name} Logo`} style={styles.logoImage} />
            </a>

            <nav style={styles.navSection}>
              <a href="https://sobekglobal.com/" style={styles.navLink}>Home</a>
              <span style={styles.navSep}>|</span>

              <a href="https://sobekglobal.com/services/" style={styles.navLink}>
                Services <span style={styles.navCaret}>▾</span>
              </a>
              <span style={styles.navSep}>|</span>

              <a href="https://sobekglobal.com/training/" style={styles.navLink}>
                Training <span style={styles.navCaret}>▾</span>
              </a>
              <span style={styles.navSep}>|</span>

              <a href="https://sobekglobal.com/store/" style={styles.navLink}>
                Store <span style={styles.navCaret}>▾</span>
              </a>
              <span style={styles.navSep}>|</span>

              <a href="https://sobekglobal.com/our-company/" style={styles.navLink}>
                Our Company <span style={styles.navCaret}>▾</span>
              </a>
              <span style={styles.navSep}>|</span>

              <a href="https://sobekglobal.com/contact-us/" style={styles.navLink}>Contact Us</a>
            </nav>

            <div style={styles.headerActions}>
              <a href="https://sobekglobal.com/sign-in/" style={styles.signBtn}>Sign In</a>
              <a
                href="https://sobekglobal.com/sign-in-beta/"
                style={{ ...styles.signBtn, marginLeft: 16 }}
              >
                Sign In (BETA)
              </a>
            </div>
          </div>
        </div>
      )}

      <div style={styles.container}>
        <div style={styles.leftPanel}>
          <h2 style={styles.welcomeTitle}>Welcome{isRegister ? '!' : ' back!'}</h2>
          <p style={styles.welcomeText}>
            {isRegister
              ? 'Start your journey in the vast lands of'
              : 'We’re very glad to see you back. Continue your journey in the vast lands of'}
            &nbsp;
            <a href={brand.siteUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#C18429', fontWeight: 'bold', textDecoration: 'none' }}>
              {brand.name.toUpperCase()}
            </a>
          </p>

          <div style={styles.noteBox}>
            <strong>Note:</strong> The Account you create here is automatically synced with our Digital Platform.
          </div>

          <div style={styles.logoRow}>
            <a href={brand.siteUrl} target="_blank" rel="noopener noreferrer">
              <img src={brand.logo} alt={brand.name} style={styles.logo} />
            </a>
            <a href={brand.siteUrl} target="_blank" rel="noopener noreferrer">
              <img src={brand.logo} alt={brand.name} style={styles.logo} />
            </a>
          </div>
        </div>

        <div style={styles.rightPanel}>
          {bannerMsg ? (
            <div style={{ ...styles.noteBox, marginBottom: 20 }}>
              {bannerMsg}
            </div>
          ) : null}

          <form style={styles.form}>
            {showResetPassword ? (
              <>
                <h2 style={{ color: '#ddd', marginBottom: '15px', fontSize: '28px', textAlign: 'left' }}>Reset Password</h2>
                <p style={{ color: '#ccc', fontSize: '16px', lineHeight: '1.6', textAlign: 'left' }}>
                  If you’ve forgotten your password, kindly reset it by following the instructions.
                  <strong style={{ display: 'block', marginTop: '10px', color: '#ddd' }}>
                    Note: This will change the password for both sites.
                  </strong>
                </p>
                <p style={{ color: '#999', fontSize: '16px', marginBottom: '10px', textAlign: 'left' }}>
                  To reset your password, please enter your email address or username below.
                </p>

                <form onSubmit={handleForgotSubmit}>
                  <input
                    type="text"
                    placeholder="Enter your username or email"
                    style={styles.input}
                    value={forgotId}
                    onChange={(e) => setForgotId(e.target.value)}
                    disabled={forgotLoading}
                  />
                  <button type="submit" style={{ ...styles.loginBtn, backgroundColor: '#30a9de' }} disabled={forgotLoading}>
                    {forgotLoading ? 'Sending...' : 'Reset password'}
                  </button>
                </form>

                <a
                  href="#"
                  onClick={(e) => { e.preventDefault(); setShowResetPassword(false); }}
                  style={styles.forgotPassword}
                >
                  Back to Login
                </a>
              </>
            ) : isRegister ? (
              <>
                <div style={styles.fieldWrap}>
                  <label htmlFor="username" style={styles.labelLeft}>
                    Username <span style={styles.requiredStarInline} aria-hidden="true">*</span>
                  </label>
                  <input id="username" name="username" type="text" style={styles.input}
                         value={username} onChange={(e) => setUsername(e.target.value)}
                         required aria-required="true" />
                </div>

                <div style={styles.fieldWrap}>
                  <label htmlFor="name" style={styles.labelLeft}>
                    Full Name <span style={styles.requiredStarInline} aria-hidden="true">*</span>
                  </label>
                  <input id="name" name="name" type="text" style={styles.input}
                         value={name} onChange={(e) => setName(e.target.value)}
                         required aria-required="true" />
                </div>

                <div style={styles.fieldWrap}>
                  <label htmlFor="email" style={styles.labelLeft}>
                    E-mail Address <span style={styles.requiredStarInline} aria-hidden="true">*</span>
                  </label>
                  <input id="email" name="email" type="email" style={styles.input}
                         value={email} onChange={(e) => setEmail(e.target.value)}
                         required aria-required="true" />
                </div>

                <div style={styles.fieldWrap}>
                  <label htmlFor="whatsapp" style={styles.labelLeft}>
                    WhatsApp number <span style={styles.requiredStarInline} aria-hidden="true">*</span>
                  </label>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <select
                      style={styles.countrySelect}
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                    >
                      {countries.map((cObj, idx) => (
                        <option key={idx} value={cObj.code}>
                          {cObj.flag} {cObj.name} ({cObj.code})
                        </option>
                      ))}
                    </select>
                    <input
                      id="whatsapp"
                      name="whatsapp"
                      type="tel"
                      style={{ ...styles.input, flex: 1, marginBottom: 0 }}
                      placeholder="5XXXXXXX"
                      value={localPhone}
                      onChange={(e) => setLocalPhone(e.target.value)}
                      required
                      aria-required="true"
                    />
                  </div>
                  <div style={{ color: '#888', fontSize: '12px', textAlign: 'left', marginTop: '4px' }}>
                    Full: {whatsappFull}
                  </div>
                </div>

                <div style={styles.fieldWrap}>
                  <label htmlFor="password" style={styles.labelLeft}>
                    Password <span style={styles.requiredStarInline} aria-hidden="true">*</span>
                  </label>
                  <input id="password" name="password" type="password" style={styles.input}
                         value={password} onChange={(e) => setPassword(e.target.value)}
                         required aria-required="true" />
                </div>

                <div style={styles.fieldWrap}>
                  <label htmlFor="confirmPassword" style={styles.labelLeft}>
                    Confirm Password <span style={styles.requiredStarInline} aria-hidden="true">*</span>
                  </label>
                  <input id="confirmPassword" name="confirmPassword" type="password" style={styles.input}
                         value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                         required aria-required="true" />
                </div>

                <button type="button" style={{ ...styles.loginBtn, marginTop: '15px' }} onClick={handleRegister} disabled={loading}>
                  {loading ? 'Please wait...' : 'Register'}
                </button>

                <div style={styles.dividerRow}>
                  <span style={styles.dividerLine}></span>
                  <span style={styles.dividerText}>or</span>
                  <span style={styles.dividerLine}></span>
                </div>
                <button type="button" style={styles.googleBtn} onClick={handleGoogleAuth}>
                  <span style={styles.googleIcon} aria-hidden>
                    <svg width="18" height="18" viewBox="0 0 48 48">
                      <path d="M44.5 20H24v8.5h11.8C34.8 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.2 0 6.2 1.2 8.5 3.2l6-6C34.7 4.3 29.6 2 24 2 16.1 2 9.2 6.6 6.3 14.7z" fill="#FFC107"/>
                      <path d="M24 46c5.5 0 10.6-1.8 14.5-5l-6.7-5.5C29.5 36.7 26.9 37.5 24 37c-6.1 0-10.8-3.9-12.5-9.2l-7.1 5.5C7.2 40.6 15 46 24 46z" fill="#4CAF50"/>
                      <path d="M44.5 20H24v8.5h11.8c-1 3.1-3.3 5.5-6.4 6.9l6.7 5.5C38.8 39.6 42 33.7 42 26c0-2-.2-4-.5-6z" fill="#1976D2"/>
                      <path d="M6.3 14.7l7 5.1C14.9 17 19 14 24 14c3.2 0 6.2 1.2 8.5 3.2l6-6C34.7 4.3 29.6 2 24 2 16.1 2 9.2 6.6 6.3 14.7z" fill="#FF3D00"/>
                    </svg>
                  </span>
                  Continue with Google
                </button>

                <button type="button" style={{ ...styles.googleBtn, marginTop: 8 }} onClick={openMobileModal}>
                  <span style={styles.googleIcon} aria-hidden>
                    <FontAwesomeIcon icon={faPhone} />
                  </span>
                  Continue with Mobile (OTP)
                </button>
              </>
            ) : (
              <>
                <label style={{ ...styles.labelLeft }}>Username or E-mail</label>
                <input type="text" style={styles.input} value={emailOrUsername} onChange={(e) => setEmailOrUsername(e.target.value)} />
                <label style={{ ...styles.labelLeft }}>Password</label>
                <input type="password" style={styles.input} value={passwordValue} onChange={(e) => setPasswordValue(e.target.value)} />
                <div style={styles.checkboxRow}>
                  <input type="checkbox" id="keepSignedIn" />
                  <label htmlFor="keepSignedIn" style={styles.checkboxLabel}>Keep me signed in</label>
                </div>
                <button type="button" onClick={handleLogin} style={styles.loginBtn}>Login</button>
                <a href="#" onClick={(e) => { e.preventDefault(); setShowResetPassword(true); }} style={styles.forgotPassword}>Forgot your password?</a>

                <div style={styles.dividerRow}>
                  <span style={styles.dividerLine}></span>
                  <span style={styles.dividerText}>or</span>
                  <span style={styles.dividerLine}></span>
                </div>
                <button type="button" style={styles.googleBtn} onClick={handleGoogleAuth}>
                  <span style={styles.googleIcon} aria-hidden>
                    <svg width="18" height="18" viewBox="0 0 48 48">
                      <path d="M44.5 20H24v8.5h11.8C34.8 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.2 0 6.2 1.2 8.5 3.2l6-6C34.7 4.3 29.6 2 24 2 16.1 2 9.2 6.6 6.3 14.7z" fill="#FF3D00"/>
                      <path d="M24 46c5.5 0 10.6-1.8 14.5-5l-6.7-5.5C29.5 36.7 26.9 37.5 24 37c-6.1 0-10.8-3.9-12.5-9.2l-7.1 5.5C7.2 40.6 15 46 24 46z" fill="#4CAF50"/>
                      <path d="M44.5 20H24v8.5h11.8c-1 3.1-3.3 5.5-6.4 6.9l6.7 5.5C38.8 39.6 42 33.7 42 26c0-2-.2-4-.5-6z" fill="#1976D2"/>
                      <path d="M6.3 14.7l7 5.1C14.9 17 19 14 24 14c3.2 0 6.2 1.2 8.5 3.2l6-6C34.7 4.3 29.6 2 24 2 16.1 2 9.2 6.6 6.3 14.7z" fill="#FF3D00"/>
                    </svg>
                  </span>
                  Continue with Google
                </button>

                <button type="button" style={{ ...styles.googleBtn, marginTop: 8 }} onClick={openMobileModal}>
                  <span style={styles.googleIcon} aria-hidden>
                    <FontAwesomeIcon icon={faPhone} />
                  </span>
                  Continue with Mobile (OTP)
                </button>
              </>
            )}

            <div style={styles.buttonRow}>
              {!isRegister && (
                <button type="button" style={{ ...styles.loginBtn }} onClick={handleLogin}>Login</button>
              )}
              <button type="button" style={{ ...styles.registerBtn }} onClick={() => setIsRegister(!isRegister)}>
                {isRegister ? 'Back to Login' : 'Go to Register'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {showMobileModal && (
        <div style={styles.modalBackdrop} onClick={closeMobileModal}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, color: '#fff' }}>
                {mobileStep === 'enter' ? 'Continue with Mobile' : 'Enter Verification Code'}
              </h3>
              <button onClick={closeMobileModal} style={styles.modalClose}>×</button>
            </div>

            {mobileStep === 'enter' ? (
              <>
                <label style={styles.labelLeft}>Mobile Number</label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <select
                    style={styles.countrySelect}
                    value={mobileCountryCode}
                    onChange={(e) => setMobileCountryCode(e.target.value)}
                  >
                    {countries.map((cObj, idx) => (
                      <option key={idx} value={cObj.code}>
                        {cObj.flag} {cObj.name} ({cObj.code})
                      </option>
                    ))}
                  </select>

                  <input
                    type="tel"
                    placeholder="5XXXXXXX"
                    style={{ ...styles.input, flex: 1, marginBottom: 0 }}
                    value={mobileLocalPhone}
                    onChange={(e) => setMobileLocalPhone(e.target.value)}
                  />
                </div>
                <div style={{ color: '#888', fontSize: '12px', textAlign: 'left', marginTop: '4px' }}>
                  Full: {mobilePhoneFull}
                </div>

                <button type="button" style={{ ...styles.loginBtn, marginTop: '12px' }} onClick={handleMobileSend} disabled={mobileLoading}>
                  {mobileLoading ? 'Sending...' : 'Send Code'}
                </button>
              </>
            ) : (
              <>
                <p style={{ color: '#ccc', marginTop: 8, marginBottom: 6, textAlign: 'left' }}>
                  We sent a 6-digit code to <strong>{mobilePhoneFull}</strong>
                </p>
                <label style={styles.labelLeft}>Verification Code</label>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  placeholder="123456"
                  style={styles.input}
                  value={mobileOtp}
                  onChange={(e) => setMobileOtp(e.target.value)}
                />
                <div style={{ display: 'flex', gap: 8 }}>
                  <button type="button" style={styles.registerBtn} onClick={() => setMobileStep('enter')} disabled={mobileLoading}>
                    Change Number
                  </button>
                  <button type="button" style={styles.loginBtn} onClick={handleMobileVerify} disabled={mobileLoading}>
                    {mobileLoading ? 'Verifying...' : 'Verify & Continue'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {mode === 'normal' && (
        <>
          <footer style={styles.footer}>
            <div style={styles.footerColWide}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <img
                  src={brand.logo}
                  alt={`${brand.name} Logo`}
                  style={{ height: 100, objectFit: 'contain' }}
                />
              </div>

              <p style={styles.footerAbout}>
                SOBEK® is a leader in comprehensive geospatial and surveying services,
                addressing the full spectrum of mapping, analysis, and environmental
                study needs. Our expertise spans mobile mapping, GIS solutions, VRS
                station deployment, land surveying, satellite imagery procurement,
                drone surveying, training, consultancy, and integrated solution
                development.
              </p>

              <div style={styles.socialRow}>
                <a href="#" style={styles.socialIcon}><i className="fa fa-facebook" /></a>
                <a href="#" style={styles.socialIcon}><i className="fa fa-instagram" /></a>
                <a href="#" style={styles.socialIcon}><i className="fa fa-twitter" /></a>
              </div>
            </div>

            <div style={styles.footerColMid}>
              <h4 style={styles.footerSectionTitle}>Quick Links</h4>

              <a href="https://sobekglobal.com/" style={styles.footerLinkNav}>Home</a>

              <div style={styles.footerLinkNavRow}>
                <a href="https://sobekglobal.com/services/" style={styles.footerLinkNav}>
                  Services <span style={styles.caret}>▾</span>
                </a>
              </div>

              <div style={styles.footerLinkNavRow}>
                <a href="https://sobekglobal.com/training/" style={styles.footerLinkNav}>
                  Training <span style={styles.caret}>▾</span>
                </a>
              </div>

              <div style={styles.footerLinkNavRow}>
                <a href="https://sobekglobal.com/store/" style={styles.footerLinkNav}>
                  Store <span style={styles.caret}>▾</span>
                </a>
              </div>

              <div style={styles.footerLinkNavRow}>
                <a href="https://sobekglobal.com/our-company/" style={styles.footerLinkNav}>
                  Our Company <span style={styles.caret}>▾</span>
                </a>
              </div>

              <a href="https://sobekglobal.com/contact-us/" style={styles.footerLinkNav}>Contact Us</a>
            </div>

            <div style={styles.footerColRight}>
              <h4 style={styles.footerContactTitle}>Get In Touch</h4>

              <div style={styles.contactLine}>
                <span style={styles.contactIcon}>📍</span>
                <span style={styles.contactText}>Headquarter - New Capital, Egypt.</span>
              </div>

              <div style={styles.contactLine}>
                <span style={styles.contactIcon}>📍</span>
                <span style={styles.contactText}>Branch - Riyadh, Saudi Arabia.</span>
              </div>

              <div style={styles.contactLine}>
                <span style={styles.contactIcon}>📞</span>
                <span style={styles.contactText}>+20 102 143 5596</span>
              </div>

              <div style={styles.contactLine}>
                <span style={styles.contactIcon}>📞</span>
                <span style={styles.contactText}>+966 57 842 8969</span>
              </div>

              <div style={styles.contactLine}>
                <span style={styles.contactIcon}>🌐</span>
                <a
                  href="https://sobekglobal.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.contactLink}
                >
                  www.sobekglobal.com
                </a>
              </div>

              <div style={styles.contactLine}>
                <span style={styles.contactIcon}>✉️</span>
                <a
                  href="mailto:Info@sobekglobal.com"
                  style={styles.contactLink}
                >
                  Info@sobekglobal.com
                </a>
              </div>
            </div>
          </footer>

          <div style={styles.footerBottomBar}>
            <div style={styles.footerBottomInner}>
              SOBEK® All Rights Reserved © 2025
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: '#111',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
    color: '#fff',
    padding: '0',
    margin: '0',
  },
  header: {
    backgroundColor: '#0b0b0b',
    borderBottom: '1px solid #0e2b2b',
    position: 'sticky',
    top: 0,
    zIndex: 20,
  },
  headerInner: {
    maxWidth: 1280,
    margin: '0 auto',
    padding: '10px 24px',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    gap: 16,
  },
  logoSection: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  logoImage: {
    height: 64,
    display: 'block',
  },
  navSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 14,
    flexWrap: 'wrap',
  },
  navLink: {
    color: '#ffffff',
    textDecoration: 'none',
    fontSize: 16,
    fontWeight: 700,
  },
  navSep: {
    color: '#00e0d0',
    opacity: 0.9,
    fontWeight: 700,
    margin: '0 2px',
  },
  navCaret: {
    fontSize: 12,
    marginLeft: 4,
    color: '#00e0d0',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
  },
  signBtn: {
    background: '#c79231',
    color: '#000',
    textDecoration: 'none',
    padding: '10px 18px',
    borderRadius: 999,
    fontWeight: 800,
    fontSize: 15,
    display: 'inline-block',
  },
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    width: '80%',
    maxWidth: '1100px',
    margin: '30px auto 60px',
    backgroundColor: 'transparent',
    borderRadius: '0',
    boxShadow: 'none',
    border: '0',
  },
  leftPanel: {
    padding: '0 20px 20px 20px',
  },
  rightPanel: {
    padding: '0 20px 20px 20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    backgroundColor: 'transparent',
  },
  welcomeTitle: {
    fontSize: '28px',
    marginBottom: '15px',
    fontWeight: 'bold',
  },
  welcomeText: {
    fontSize: '17px',
    color: '#ccc',
    lineHeight: '1.6',
    marginBottom: '20px',
  },
  noteBox: {
    backgroundColor: '#d8f9d1',
    padding: '10px',
    borderRadius: '5px',
    color: '#111',
    fontSize: '14px',
    marginBottom: '20px',
  },
  logoRow: {
    display: 'flex',
    gap: '30px',
    marginTop: '30px',
    height: '80px',
  },
  logo: {
    height: '70px',
    objectFit: 'contain',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  fieldWrap: {
    position: 'relative',
    display: 'grid',
    marginTop: 6,
  },
  requiredStarInline: {
    color: '#e53935',
    fontWeight: 900,
    marginLeft: 4,
    fontSize: 16,
  },
  requiredStar: {
    position: 'absolute',
    top: -10,
    left: 0,
    color: '#e53935',
    fontWeight: 900,
    lineHeight: 1,
    fontSize: 16,
    pointerEvents: 'none',
    userSelect: 'none',
  },
  labelLeft: {
    marginTop: '15px',
    marginBottom: '5px',
    fontSize: '14px',
    color: '#ccc',
    textAlign: 'left',
    fontWeight: 700,
  },
  input: {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginBottom: '10px',
    backgroundColor: '#fff',
    color: '#000',
    fontSize: '14px',
  },
  countrySelect: {
    backgroundColor: '#fff',
    color: '#000',
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '10px',
    fontSize: '14px',
    minWidth: '140px',
    height: '42px',
    lineHeight: '20px',
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0',
  },
  checkboxLabel: {
    marginLeft: '8px',
    fontSize: '14px',
    color: '#ccc',
  },
  buttonRow: {
    display: 'flex',
    gap: '10px',
    marginTop: '15px',
  },
  loginBtn: {
    flex: 1,
    backgroundColor: '#30a9de',
    color: '#fff',
    border: 'none',
    padding: '10px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  registerBtn: {
    flex: 1,
    backgroundColor: '#e6e6e6',
    color: '#000',
    border: 'none',
    padding: '10px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  forgotPassword: {
    marginTop: '15px',
    color: '#ccc',
    fontSize: '13px',
    textDecoration: 'underline',
    textAlign: 'right',
    display: 'block',
  },
  dividerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    margin: '18px 0 10px',
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: '#333',
  },
  dividerText: {
    color: '#999',
    fontSize: 12,
  },
  googleBtn: {
    width: '100%',
    backgroundColor: '#fff',
    color: '#000',
    border: '1px solid #ddd',
    padding: '10px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    marginTop: 6,
  },
  googleIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  footer: {
    backgroundColor: '#0d0d0d',
    borderTop: 'none',
    color: '#fff',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '20px',
    paddingTop: '30px',
    gap: '30px',
  },
  footerColWide: {
    flex: '1 1 320px',
    maxWidth: '500px',
    color: '#ccc',
    fontSize: '14px',
    lineHeight: '1.5',
    minWidth: '260px',
  },
  footerAbout: {
    color: '#ccc',
    fontSize: '14px',
    lineHeight: '1.5',
    marginTop: '10px',
    marginBottom: '15px',
    textAlign: 'left',
  },
  socialRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: '#1ba99e',
    fontSize: '18px',
  },
  socialIcon: {
    color: '#1ba99e',
    textDecoration: 'none',
    fontSize: '18px',
  },
  footerColMid: {
    flex: '1 1 200px',
    minWidth: '200px',
    maxWidth: '240px',
    color: '#ccc',
    fontSize: '14px',
    lineHeight: '1.6',
    display: 'flex',
    flexDirection: 'column',
  },
  footerSectionTitle: {
    color: '#1ba99e',
    fontWeight: 700,
    fontSize: '16px',
    marginBottom: '12px',
  },
  footerLinkNavRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  footerLinkNav: {
    color: '#ccc',
    textDecoration: 'none',
    fontSize: '14px',
    lineHeight: '1.8',
    display: 'inline-block',
  },
  caret: {
    color: '#ccc',
    fontSize: '12px',
    marginLeft: '4px',
  },
  footerColRight: {
    flex: '1 1 260px',
    minWidth: '240px',
    maxWidth: '320px',
    color: '#ccc',
    fontSize: '14px',
    lineHeight: '1.6',
  },
  footerContactTitle: {
    color: '#1ba99e',
    fontWeight: 700,
    fontSize: '16px',
    marginBottom: '15px',
  },
  contactLine: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    color: '#ccc',
    fontSize: '14px',
    lineHeight: '1.5',
    marginBottom: '10px',
  },
  contactIcon: {
    minWidth: '18px',
    fontSize: '14px',
    lineHeight: '1.4',
    color: '#C18429',
  },
  contactText: {
    color: '#ccc',
    fontSize: '14px',
    lineHeight: '1.5',
  },
  contactLink: {
    color: '#ccc',
    textDecoration: 'none',
    fontSize: '14px',
    lineHeight: '1.5',
    wordBreak: 'break-word',
  },
  footerBottomBar: {
    backgroundColor: '#d8b777',
    color: '#000',
    fontSize: '13px',
    fontWeight: 500,
    textAlign: 'center',
    padding: '10px 20px',
  },
  footerBottomInner: {
    maxWidth: '1280px',
    margin: '0 auto',
  },
  modalBackdrop: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    width: '100%',
    maxWidth: 420,
    background: '#1a1a1a',
    border: '1px solid #333',
    borderRadius: 10,
    padding: 20,
    boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
  },
  modalClose: {
    background: 'transparent',
    color: '#fff',
    border: 0,
    fontSize: 22,
    cursor: 'pointer',
    lineHeight: 1,
  },
};

export default LoginRegisterSobek;
